export default __webpack_public_path__ + "static/media/number6.aaf2dcdd.svg";